import { render, staticRenderFns } from "./SelectAge.vue?vue&type=template&id=f3118c48&scoped=true&"
import script from "./SelectAge.vue?vue&type=script&lang=ts&"
export * from "./SelectAge.vue?vue&type=script&lang=ts&"
import style0 from "./SelectAge.vue?vue&type=style&index=0&id=f3118c48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3118c48",
  null
  
)

export default component.exports